/**
=========================================================
* Soft UI Dashboard PRO React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const gradientLineChartData = {
  labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  datasets: [
    {
      label: "Total Male",
      color: "warning",
      data: [50, 40, 100, 150, 120, 160, 150, 170, 130],
    },
    {
      label: "Total Female",
      color: "dark",
      data: [30, 90, 40, 100, 200, 150, 190, 160, 150],
    },
  ],
};

export default gradientLineChartData;
